import { render, staticRenderFns } from "./StepMaterials.vue?vue&type=template&id=f2cb93ba&lang=html&"
import script from "./StepMaterials.vue?vue&type=script&lang=js&"
export * from "./StepMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports